import geobuf from 'geobuf';
import Pbf from 'pbf';
import { ActiveRecordSource } from '../ActiveRecordSource.js';
class ActiveRecordGeobufSource extends ActiveRecordSource {
    /**
     * @param {object} response
     * @return {Promise<object>}
     */
    // eslint-disable-next-line class-methods-use-this
    transformResponse(response) {
        return (response.headers.get('Content-Type') === 'application/x-protobuf'
            ? response.arrayBuffer().then((buffer) => (geobuf.decode(new Pbf(buffer))))
            : Promise.resolve(response));
    }
    /**
     * @param {object} responseBody
     * @return {Promise<object>}
     */
    // eslint-disable-next-line class-methods-use-this
    transformResponseRecords(responseBody) {
        return [responseBody];
    }
    /**
     * @param {object} props
     * @return {*}
     */
    transformRequestBody(props) {
        const body = { ...props };
        delete body.$status;
        const encoded = geobuf.encode(body, new Pbf());
        return encoded;
    }
}
ActiveRecordGeobufSource.defaults = {
    headers: {
        'Content-Type': 'application/x-protobuf',
    },
};
export default ActiveRecordGeobufSource;
